<template>
  <div class="nav_wrapper">
    <div class="nav flex_box ios">
      <div class="flex_item nav_item flex_box" @click="tapTabBar('/salesAdd')">
        <van-image
          width="30"
          height="30"
          fit="contain"
          :src="store.ptInfo.service_icon"
        />
        <div class="nav_label">{{ $t("navigation.function_card_sell") }}</div>
      </div>

      <div
        class="flex_item nav_item scan-wrapper flex_box relative"
        @click="tapTabBar('/scanCodeAdd', 1)"
      >
        <van-image
          class="scan-icon-wrapper"
          width="78"
          height="78"
          fit="contain"
          :src="store.ptInfo.code_icon"
        />
        <div class="nav_label">{{ $t("navigation.Scanning_code_found") }}</div>
      </div>

      <div
        class="flex_item nav_item relative flex_box"
        @click="tapTabBar('/notice')"
      >
        <van-image
          width="30"
          height="30"
          fit="contain"
          :src="store.ptInfo.notice_icon"
        />
        <div v-if="msgCount > 0" class="msg_count">{{ msgCount }}</div>
        <div class="nav_label">{{ $t("navigation.news_notice") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  props: {
    msgCount: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    const router = useRouter();
    const store = useStore().state;
    const tapTabBar = (path, type) => {
      let data = {
        path: path,
      };
      if (type) {
        //用于判断缓存页面
        sessionStorage.setItem("cleanup", 1);
      }
      router.push(data);
    };
    return {
      tapTabBar,
      store,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.propsWid {
  width: 78px;
  height: 78px;
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
}

.nav_wrapper {
  height: 60px;
}

.nav {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 9;
  width: 100%;
  height: 75px;
  background-color: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.7);
}

.nav_item {
  text-align: center;
  flex-flow: column;
  justify-content: flex-end;
  align-items: center;
}

/*.nav_icon {
  font-size: 24px;
}*/
.nav_label {
  font-size: 12px;
  margin: 5px 0;
  color: #333;
  padding: 0px 10px;
}

.msg_count {
  position: absolute;
  top: 2px;
  left: 50%;
  margin-left: 5px;
  height: 16px;
  line-height: 16px;
  color: #fff;
  background-color: #f00;
  border-radius: 8px;
  padding: 0 5px;
  font-size: 11px;
}

.scan-wrapper .nav_label {
  position: relative;
  z-index: 10;
}

.scan-icon-wrapper {
  position: absolute;
  top: -37.5px;
  left: 50%;
  transform: translateX(-50%);
}

.container {
  padding: 0 15px;
}

.detail-wrapper {
  border-radius: 6px;
  margin-bottom: 10px;
  overflow: hidden;
}

.add-wrapper {
  border-radius: 6px;
  background: #fff;
  margin-bottom: 10px;
  overflow: hidden;
}

.link-wrapper {
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 80rpx;
}

.link-wrapper-icon {
  margin-right: 15px;
  position: relative;
}

.contentapp {
  padding-top: 10px;
}

.contentapp .swiper-item {
  display: flex;
  align-items: center;
}

.flex_box {
  display: flex;
}
</style>
